/**
 * App-level 브라우저 back 가드 상태.
 * 모듈 레벨 플래그 — popstate 리스너에서 동기(stale-closure 무관)로 무장 여부를 읽는다.
 *
 * 원리: 카메라-런치 탭은 히스토리가 얕아 back 시 탭이 조용히 닫힌다. Splash의 "Tap to Start"
 * 등 사용자 제스처에서 동기 pushState를 한 번 하면(→ Chromium이 non-skippable로 취급),
 * back이 탭을 안 닫고 popstate로 잡힌다. 그때 BackGuard가 Leave/Stay 모달을 메뉴 위에 띄운다.
 * 재무장(Stay)도 반드시 사용자 제스처에서 pushState 해야 non-skippable이 유지된다.
 */
let armed = false;

export function armBackGuard(): void { armed = true; }
export function disarmBackGuard(): void { armed = false; }
export function isBackGuardArmed(): boolean { return armed; }
